// extracted by mini-css-extract-plugin
export var backButton = "_u-1";
export var content = "_u-d";
export var continueButton = "_u-7";
export var continueHint = "_u-8";
export var continueRow = "_u-6";
export var leftInner = "_u-0";
export var shell = "_u-e";
export var sidebarContent = "_u-5";
export var skipButton = "_u-c";
export var spacer = "_u-2";
export var spin = "_u-a";
export var spinner = "_u-9";
export var spinnerOverlay = "_u-b";
export var subtitle = "_u-4";
export var title = "_u-3";